import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin } from 'rxjs';
import { EActivitySimulationType } from 'src/app/domain/enums/activity-simulation-type';
import { EBuildingType } from 'src/app/domain/enums/building-type';
import { EMasterDataType } from 'src/app/domain/enums/master-data-type';
import { ERoomUsage } from 'src/app/domain/enums/room-usage';
import { MPCA } from 'src/app/domain/mpca';
import { Zone } from 'src/app/domain/zone';
import { MasterDataService } from 'src/app/services/master-data.service';
import { StringConverter } from '../string-converter';
import { EDegradationLevel } from 'src/app/domain/enums/degradation-level';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-zone-conformite-box',
    templateUrl: './zone-conformite-box.html',
    styleUrls: ['./zone-conformite-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZoneConformiteBoxDialog implements OnInit {

    @ViewChild('autosize') autosize?: CdkTextareaAutosize;

    public BuildingTypeList: string[] = Object.values(EBuildingType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getBuildingTypeName(x));

    public UsageList: string[] = Object.values(ERoomUsage)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getRoomUsageTypeName(x));

    public SimulationTypeList: string[] = Object.values(EActivitySimulationType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getActivitySimulationTypeName(x));

    // public DegradationLevelList: string[] = Object.values(EDegradationLevel)
    //     .filter(x => !isNaN(Number(x)))
    //     .map((x: any) => StringConverter.getDegradationLevelName(x));

    public Model!: Zone;
    SelectedMPCAList: MPCA[] = [];
    public ProtectionList: string[] = [];

    constructor(
        private masterDataService: MasterDataService,
        public dialogRef: MatDialogRef<ZoneConformiteBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: Zone) {

        if (data) {
            this.retrieveMasterData();
            this.Model = Object.assign({}, data)
            this.SelectedMPCAList = this.Model.MpcaList;
        }

    }

    ngOnInit() {

    }

    getDegradationLevelName(level: EDegradationLevel) {
        return StringConverter.getDegradationLevelName(level)
    }

    retrieveMasterData() {
        forkJoin([
            this.masterDataService.getMasterDataByType(EMasterDataType.OnSiteProtectionAndSealingType),
        ]).subscribe(async ([p]) => {
            this.ProtectionList = p;
        })
    }

    public compareWith(m1: MPCA, m2: MPCA) {
        return m1 && m2 ? m1.ScolaMaterial === m2.ScolaMaterial : m1 === m2;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.Model.MpcaList = this.SelectedMPCAList;
        this.dialogRef.close(this.Model);
    }
}
